import React, { useContext, useState } from "react";
import { Navbar } from "react-bootstrap";
import AdminNavbarLinks from "./AdminNavbarLinks.jsx";
import SendJobModal from "components/SendJobModal/SendJobModal.jsx";
import GlobalContext from "context/globalContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./adminNavBar.module.css";

function Header(props) {
  const globalContext = useContext(GlobalContext);
  const [sidebarExists, setSidebarExists] = useState(false);
  const [showSendModal, setShowSendModal] = useState(false);

  const mobileSidebarToggle = (e) => {
    if (sidebarExists === false) {
      setSidebarExists(true)
    }
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  }

  const onDisconnect = async (e) => {
    let sessionHelper = globalContext.session.response.helper;
    await globalContext.session.disconnect(globalContext.sessionId);
    sessionHelper
      .streams.forEach(e =>
        sessionHelper.session.forceUnpublish(e.streamId, (resp) => console.log(resp))
      );
  }

  const onSendJob = () => {
    setShowSendModal(true);
  }


  return (
    <React.Fragment>
      <Navbar fluid>
        
        <Navbar.Brand className="ml-2">{globalContext.job.response && 
        globalContext.job.response.details
        ? `${globalContext.job.response.details.bmsJobNumber} - ${globalContext.job.response.details.customer.street} ${globalContext.job.response.details.customer.suburb } ${globalContext.job.response.details.customer.state} ${globalContext.job.response.details.customer.postalCode}` 
        : <FontAwesomeIcon icon="spinner" spin className={styles.jobNumberSpinner} />}</Navbar.Brand>
        
        <Navbar.Header>
          <Navbar.Toggle onClick={mobileSidebarToggle} />
        </Navbar.Header>
        <Navbar.Collapse>
          {globalContext.job.response.details && <AdminNavbarLinks videoConnected={props.videoConnected}
            signalRConnected={props.signalRConnected}
            clientLocation={props.clientLocation}
            onDisconnect={onDisconnect}
            onSendJob={onSendJob}
          />
          }
        </Navbar.Collapse>
      </Navbar>
      {globalContext.job.response.details &&
        <SendJobModal
          show={showSendModal}
          onClose={() => setShowSendModal(false)}
          mobileNumber={globalContext.job.response.details.customer.mobilePhone}
          email={globalContext.job.response.details.customer.emailAddress}
          sessionId={globalContext.sessionId}
        />
      }
    </React.Fragment>
  );
}

export default Header;
